/**
 * Creates a new query object to identify installed domains
 * @returns {Object} - Query for domains that had page views in the last year
 */
export const queryInstalledDomains = () => ({
  metrics: ['page_views'],
  start_time: '1 year ago',
  dimensions: ['hostname'],
});

export const queryFlowsMetricsAnalytics = () => ({
  start_time: 1,
  metrics: ['flow_users', 'flow_completed_users'],
  dimensions: ['flow_id'],
});
